/**
 * @generated SignedSource<<19aad1e32023e3ae189d95fdd7afb1c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignGroupTemplate$data = {
  readonly flow: {
    readonly name: string;
    readonly rowId: UUID;
  } | null | undefined;
  readonly moduleGroupLinksByModuleGroupFlowId: {
    readonly nodes: ReadonlyArray<{
      readonly moduleFlow: {
        readonly flow: {
          readonly durationSeconds: number;
          readonly flowReviewers: {
            readonly nodes: ReadonlyArray<{
              readonly reviewer: {
                readonly fullName: string;
              } | null | undefined;
            }>;
          };
          readonly name: string;
        } | null | undefined;
      } | null | undefined;
    }>;
  };
  readonly " $fragmentType": "AssignGroupTemplate";
};
export type AssignGroupTemplate$key = {
  readonly " $data"?: AssignGroupTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssignGroupTemplate">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssignGroupTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ModuleGroupLinksConnection",
      "kind": "LinkedField",
      "name": "moduleGroupLinksByModuleGroupFlowId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ModuleGroupLink",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Module",
              "kind": "LinkedField",
              "name": "moduleFlow",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Flow",
                  "kind": "LinkedField",
                  "name": "flow",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationSeconds",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FlowReviewersConnection",
                      "kind": "LinkedField",
                      "name": "flowReviewers",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FlowReviewer",
                          "kind": "LinkedField",
                          "name": "nodes",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "GwtUser",
                              "kind": "LinkedField",
                              "name": "reviewer",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "fullName",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flow",
      "kind": "LinkedField",
      "name": "flow",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ModuleGroup",
  "abstractKey": null
};
})();

(node as any).hash = "4aea9a4e499f98c714eac4ef6360ac6b";

export default node;
